
import React from "react";
import { NavLink } from 'react-bootstrap';

class ConditionalLink extends React.Component {

    render() {
        if (this.props.display) {
            return (
                <NavLink className={this.props.className} href={this.props.href} onClick={this.props.onClick}>{this.props.caption}</NavLink>
            )
        }
        return null;
    }
}

export default ConditionalLink;
